import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function AddRatecard() {
  const [shopId, setShopId] = useState("all"); // Default to "all"
  const [category, setCategory] = useState("");
  const [Description, setDescription] = useState("");
  const [ServiceCharge, setServiceCharge] = useState("");
  const [shops, setShops] = useState([]);
  const [categories, setCategories] = useState([]);

  // Fetch all vendors
  useEffect(() => {
    axios
      .get("https://visitguru.in/api/v1/freelancer/getAllfreelancer")
      .then((res) => {
        setShops(res.data?.data || []);
      })
      .catch((error) => {
        console.error("Error fetching shops:", error);
        toast.error("Failed to fetch shops.");
      });
  }, []);

  // Fetch categories based on shopId
  useEffect(() => {
    if (shopId) {
      const endpoint =
        shopId === "all"
          ? "https://visitguru.in/api/v1/category/getCategory"
          : `https://visitguru.in/api/v1/category/getCatbyadmin/${shopId}`;

      axios
        .get(endpoint)
        .then((res) => {
          setCategories(res.data?.data || []);
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
          toast.error("Failed to fetch categories.");
        });
    } else {
      setCategories([]);
    }
    // Don't reset category here, so it stays selected
  }, [shopId]);

  const handleSubmit = async () => {
    if (!category) {
      toast.error("Please select a category.");
      return;
    }
    if (!Description) {
      toast.error("Please enter description.");
      return;
    }
    if (!ServiceCharge) {
      toast.error("Please enter service charge.");
      return;
    }

    const payload = {
      Description,
      ServiceCharge: ServiceCharge ? parseFloat(ServiceCharge) : undefined,
      category,
    };

    if (shopId === "all") {
      payload.shopId = shops.map((shop) => shop._id);
    } else if (shopId) {
      payload.shopId = shopId;
    }

    try {
      const response = await axios.post(
        "https://visitguru.in/api/v1/ratecard/addRatecard",
        payload
      );

      if (response.status === 201) {
        toast.success("Rate card added successfully!");
        setDescription("");
        setServiceCharge("");
        // Keep category as it is — don't reset
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to add rate card.");
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Add Rate Card</h6>
        </div>
      </div>
      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          {/* Shop */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Shop
            </label>
            <select
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              value={shopId}
              onChange={(e) => setShopId(e.target.value)}
            >
              <option value="all">All Vendors</option>
              {shops.map((shop) => (
                <option key={shop._id} value={shop._id}>
                  {shop.shopName}
                </option>
              ))}
            </select>
          </div>

          {/* Category */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Category
            </label>
            <select
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.categoryName}
                </option>
              ))}
            </select>
          </div>

          {/* Description */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Description
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              placeholder="Enter Description"
              value={Description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>

          {/* Service Charge */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Service Charge
            </label>
            <input
              type="number"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              placeholder="Enter Service Charge"
              value={ServiceCharge}
              onChange={(e) => setServiceCharge(e.target.value)}
            />
          </div>

          {/* Submit */}
          <div className="flex justify-end w-full">
            <button
              type="button"
              onClick={handleSubmit}
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs mt-2 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
            >
              Add Rate Card
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddRatecard;
